(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const grids = document.querySelectorAll('[data-slideshow]');

    grids.forEach(function(grid) {
      const allSlides = Array.from(grid.querySelectorAll('.hero__slide'));
      if (allSlides.length === 0) return;

      function isMobileViewport() {
        return window.innerWidth < 750;
      }

      function getActiveSlides() {
        if (isMobileViewport()) {
          // On mobile: prefer --mobile slides; fall back to --desktop if none exist
          const mobileSlides = allSlides.filter(function(s) {
            return s.classList.contains('hero__media-wrapper--mobile');
          });
          if (mobileSlides.length > 0) return mobileSlides;
          return allSlides.filter(function(s) {
            return s.classList.contains('hero__media-wrapper--desktop');
          });
        } else {
          // On desktop: only --desktop slides
          return allSlides.filter(function(s) {
            return s.classList.contains('hero__media-wrapper--desktop');
          });
        }
      }

      let timer;

      function init() {
        clearInterval(timer);

        // Deactivate all slides
        allSlides.forEach(function(s) { s.classList.remove('is-active'); });

        // Remove existing dots
        const existingDots = grid.parentElement.querySelector('.hero__slideshow-dots');
        if (existingDots) existingDots.remove();

        const slides = getActiveSlides();
        if (slides.length === 0) return;

        slides[0].classList.add('is-active');
        if (slides.length < 2) return;

        // Build dots
        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'hero__slideshow-dots';
        slides.forEach(function(_, i) {
          const dot = document.createElement('button');
          dot.className = 'hero__slideshow-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', function() {
            goToSlide(i);
            resetTimer();
          });
          dotsContainer.appendChild(dot);
        });
        grid.parentElement.appendChild(dotsContainer);

        const dots = dotsContainer.querySelectorAll('.hero__slideshow-dot');
        let current = 0;
        const interval = parseInt(grid.dataset.interval) || 4000;

        function goToSlide(index) {
          slides[current].classList.remove('is-active');
          dots[current].classList.remove('is-active');
          current = index;
          slides[current].classList.add('is-active');
          dots[current].classList.add('is-active');
        }

        function nextSlide() {
          goToSlide((current + 1) % slides.length);
        }

        function resetTimer() {
          clearInterval(timer);
          timer = setInterval(nextSlide, interval);
        }

        resetTimer();
      }

      init();

      // Re-init when crossing the 750px breakpoint
      let lastMobile = isMobileViewport();
      window.addEventListener('resize', function() {
        const mobile = isMobileViewport();
        if (mobile !== lastMobile) {
          lastMobile = mobile;
          init();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uc-video-reel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionId = '{{ section.id }}';
  var track   = document.getElementById('ucReelTrack-' + sectionId);
  var prevBtn = document.getElementById('ucReelPrev-' + sectionId);
  var nextBtn = document.getElementById('ucReelNext-' + sectionId);
  if (!track) return;

  var items  = Array.from(track.querySelectorAll('.uc-reel__item'));
  var videos = items.map(function (i) { return i.querySelector('.uc-reel__video'); }).filter(Boolean);

  /* ── Arrows ── */
  function checkOverflow() {
    var over = track.scrollWidth > track.clientWidth + 4;
    if (prevBtn) prevBtn.style.display = over ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = over ? 'flex' : 'none';
  }
  checkOverflow();
  window.addEventListener('resize', checkOverflow);
  if (prevBtn) prevBtn.addEventListener('click', function () { scrollCard(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollCard(1); });
  function scrollCard(dir) {
    var first = items[0];
    if (!first) return;
    track.scrollBy({ left: dir * (first.offsetWidth + 20), behavior: 'smooth' });
  }

  /* ── Step 1: mute and call load() on ALL videos at once ── */
  /* ── Autoplay each video independently ── */

videos.forEach(function (video) {

    video.muted = true;

    function tryPlay() {
        video.play().catch(function () {});
    }

    if (video.readyState >= 2) {
        tryPlay();
    } else {
        video.addEventListener('canplay', tryPlay, {
            once: true
        });
    }

});

  /* ── Per-video tap + mute controls ── */
  items.forEach(function (item) {
    var video   = item.querySelector('.uc-reel__video');
    var playBtn = item.querySelector('.uc-reel__play-btn');
    var muteBtn = item.querySelector('.uc-reel__mute-btn');
    var wrap    = item.querySelector('.uc-reel__video-wrap');
    if (!video || !wrap) return;

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('.uc-reel__mute-btn')) return;
      if (video.paused) {
        video.play().catch(function () {});
        wrap.classList.remove('is-paused');
        item.removeAttribute('data-user-paused');
        if (playBtn) playBtn.querySelector('.uc-reel__play-icon').style.display = 'none';
      } else {
        video.pause();
        wrap.classList.add('is-paused');
        item.dataset.userPaused = '1';
        if (playBtn) playBtn.querySelector('.uc-reel__play-icon').style.display = 'flex';
      }
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.querySelector('.uc-reel__sound-off').style.display = video.muted ? 'flex' : 'none';
        muteBtn.querySelector('.uc-reel__sound-on').style.display  = video.muted ? 'none' : 'flex';
      });
    }
  });

  /* ── IO: pause only when fully off-screen, resume if user hadn't paused ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = entry.target;
        var v    = item.querySelector('.uc-reel__video');
        var wrap = item.querySelector('.uc-reel__video-wrap');
        if (!v) return;
        if (entry.isIntersecting) {
          if (!item.dataset.userPaused) {
            v.play().catch(function () {});
            if (wrap) wrap.classList.remove('is-paused');
          }
        } else {
          v.pause();
          if (wrap) wrap.classList.add('is-paused');
        }
      });
    }, {
    threshold: 0,
    rootMargin: "250px"
});
    items.forEach(function (item) { io.observe(item); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
